export default __webpack_public_path__ + "static/media/search.812d0444.svg";